import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import store from '@/store';
import logTrace from '@/services/logTrace';
import enums from '@/utils/enums';
import { UNIT, CONFIG } from '@/utils/constants';
import { getToken, logout, getDuplicatedEmail } from '../services/auth';
import { hasPermission } from '@/utils';

sessionStorage.removeItem('logged');

const router = new Router({
  mode: 'history',
  routes,
});

export const createNavigationTrace = (from, to) => {
  const routeName = to.name;
  const tracePath = {
    ...enums.logTraceActionRoutes[routeName],
  };
  const { matched, meta, ...fromRoute } = from;
  tracePath.details = [...(tracePath.details || []), 'fromRoute'];
  const details = {
    fromRoute: fromRoute,
    ...to.params,
  };
  if (tracePath) {
    logTrace({
      action: tracePath,
      details,
    });
  } else {
    console.warn('This route is not being logged', routeName);
  }
};

router.beforeEach((to, from, next) => {
  let routeName = '';
  let hasTologout = false;
  const noUnits =
    !store.getters[UNIT.GET_SELECTED] ||
    (!store.getters[UNIT.GET_ALL] && store.getters[UNIT.GET_ALL].length === 0);
  const hasToken = getToken();
  const duplicatedEmail = getDuplicatedEmail();
  const showBlockadeWarning = store.getters[CONFIG.SHOW_BLOCKADE_WARNING];

  if (showBlockadeWarning) {
    routeName = 'blockadeWarning';
    hasTologout = true;
  } else {
    if (to.meta.profiles && !hasPermission(to.meta.profiles)) {
      if (from && from.name) return;
      routeName = 'home';
    } else if (
      to.name === 'adminPreview' ||
      to.name === 'resetPassword' ||
      to.name === 'credits' ||
      (to.name === 'changeRepeatedEmail' && hasToken)
    ) {
      // goes directly to page
    } else if (to.name !== 'selectUnit' && noUnits && hasToken) {
      if (duplicatedEmail) {
        routeName = 'changeRepeatedEmail';
      } else {
        routeName = 'selectUnit';
      }
    } else if (
      to.matched.some((record) => record.meta.requiresAuth) &&
      !hasToken
    ) {
      routeName = 'login';
      hasTologout = true;
    } else if (to.name === 'login' && hasToken) {
      routeName = 'home';
    } else if (!checkIfHasAccess(to)) {
      routeName = from.name;
    } else if (duplicatedEmail) {
      routeName = 'changeRepeatedEmail';
    }
  }

  if (routeName) {
    if (from.name == routeName) {
      next(false);
    } else if (to.name != routeName) {
      next({
        name: routeName,
        // query: { redirect: to.fullPath }
      });
      if (hasTologout) logout();
    } else {
      next();
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  if (
    sessionStorage.getItem('logged') ||
    (from.name === 'selectUnit' && to.name === 'home')
  ) {
    createNavigationTrace(from, to);
  }
});

const checkIfHasAccess = (route) => {
  const navigationRules = store.getters[CONFIG.GET_NAVIGATION_RULES];
  if (!navigationRules?.excludeModules) return true;

  const exclude = navigationRules.excludeModules.find(
    (item) => route.meta.module === item
  );

  return exclude === undefined;
};

Vue.use(Router);
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js